export enum GestionCoStatus {
  A_TRIER = 'a-trier',
  WC_NON_VALIDE = 'wc-non-valide',
  DOSSIER_MAIRIE_EN_PREVISION = 'dossier-mairie-en-prevision',
  DOSSIER_COMPLETS_SOUS_PLI = 'dossiers-complets-sous-pli',
  EN_MAIRIE_SANS_MDG = 'en-mairie-sans-mdg',
  EN_MAIRIE = 'en-mairie',
  ACCORD_MAIRIE = 'accord-mairie',
  DOSSIER_MAIRIE_A_FAIRE = 'dossier-mairie-a-faire',
  PM_EN_ATTENTE_DE_VALIDATION = 'pm-en-attente-de-validation',
  PM_A_FAIRE = 'pm-a-faire',
  PIECES_COMP_RECUES = 'pieces-comp-reçus',
  PIECE_COMP_A_FAIRE = 'pieces-comp-a-faire',
  REFUS_RECUS = 'refus-reçus',
  REDEPOT_A_FAIRE = 'redepot-a-faire',
  PIECE_COMP_RENVOYES_EN_MAIRIE = 'pieces-comp-renvoyes-en-mairie',
  OPPOSITION = 'opposition',
  REFUS_RENVOYER_EN_MAIRIE = 'refus-renvoye-en-mairie',
  DOSSIER_EN_ATTENTE = 'dossier-en-attente',
  ANNULATION_CLIENT = 'annulation-client',
  ANNULATION_PLU = 'annulation-plu',
  ANNULATION_REFUS_MAIRIE = 'annulation-refus-mairie',
  SANS_DP_50 = 'sans-dp-50',
  TERMINE = 'termine',
}
